import axios from "axios";
import { BASE_URL_API } from "../config/env";

axios.defaults.withCredentials = true;

export const JSON_HEADERS = Object.freeze({
  "Content-Type": "application/json",
});

export const jsonRequestConfig = Object.freeze({
  headers: JSON_HEADERS,
});

export const isApiRequestUrl = (url) => {
  const value = String(url || "");
  return value.startsWith(BASE_URL_API) || value.startsWith("/");
};

export const withOrganizationHeaders = (config, org) => {
  if (!org?.id || !isApiRequestUrl(config?.url)) return config;

  return {
    ...config,
    headers: {
      ...(config?.headers || {}),
      "X-Org-Id": String(org.id),
      "X-Organization-Id": String(org.id),
    },
  };
};

export const apiClient = axios;

export default apiClient;
